
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/insurance",
      function () {
        return require("private-next-pages/use-cases/insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/insurance"])
      });
    }
  